module.exports = {
	"id": "abt543",
	"enabled": true,
	"type": "standard",
	"split": 2,
	"dateRange": [
		{
			"start": "2016-05-03T09:00:00-05:00",
			"end": "2016-05-14T23:59:59-05:00"
		}
	],
	"cookieExpiration": "2016-05-19T23:59:59-05:00",
	"evar": {
		"number": 66,
		"qa": 68,
		"name": "lazy_load_v2"
	},
	"lids": [
		".list-footer-controls .pager-prev a",
		".list-footer-controls .pager-next a"
	],
	"pageCriteria": {
		"pageType": [
			"browse,list,category",
			"browse,list,search,results"
		]
	},
	"deviceSize": [
		"s",
		"m",
		"l"
	],
	"buckets": [
		"1",
		"2",
		"3",
		"4",
		"5",
		"6",
		"7",
		"8",
		"9",
		"10"
	]
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/abt-tests/abt543/config.json
 ** module id = 36
 ** module chunks = 2
 **/